import Box from 'components/Box'
import Icon from 'components/Icon'
import PopOver from 'components/PopOver'

type Props = {
  onChange: (speed: string) => void
  isFloating?: boolean
}

const options = [
  {
    label: '0.5x',
    value: '0.5',
  },
  {
    label: '1x',
    value: '1',
  },
  {
    label: '1.5x',
    value: '1.5',
  },
  {
    label: '2x',
    value: '2',
  },
]
export default function BandWidthControl({ onChange, isFloating = false }: Props) {
  return (
    <Box ml="8px">
      <PopOver
        options={options}
        placement="auto"
        isPortaled={isFloating ? false : true}
        onChange={(value: any) => onChange(value.value)}
      >
        <Icon icon={['far', 'gauge-simple-max']} fontSize="12px" color={isFloating ? 'white' : 'grayShadeBlack2'} />
      </PopOver>
    </Box>
  )
}
